import { useTranslate } from 'core/hooks/useTranslate';
import { MAIN_CONTENT_ID } from 'core/layout/constants';
import PdfViewerFullScreen from 'core/modules/components/pdfViewers/PdfViewerFullScreen/PdfViewerFullScreen';
import * as coreEntities from 'core/store/index';
import { TERMS } from 'edelvives/config/config';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { TextHtml } from 'ui';

const TermsOfUse = () => {
  const { t } = useTranslate();
  const [showPdfViewer, setShowPdfViewer] = useState(false);
  const language = useSelector((state) => coreEntities.i18n.selectors.getLanguage(state));
  let lang = language && Object.keys(TERMS).includes(language) ? language : 'es';

  useEffect(() => {
    let elements = document.getElementsByClassName('terms');
    if (elements.length > 0) {
      document.getElementsByClassName('tyc_legal')[0].innerHTML = elements[0].innerHTML;
    }
    if (TERMS[lang] && TERMS[lang].endsWith('pdf')) {
      setShowPdfViewer(true);
    } else {
      setShowPdfViewer(false);
    }
  }, []);

  return (
    <main id={MAIN_CONTENT_ID} tabIndex={-1}>
      {showPdfViewer ? (
        <>
          <h1 className="sr-only">{t('titles:Terms')}</h1>
          <PdfViewerFullScreen ariaLabel={t('titles:Terms')} url={TERMS[lang]} />
        </>
      ) : (
        <div className="dialog-terms">
          <h1 className="dialog-terms__title">{t('titles:Terms')}</h1>
          <TextHtml text={TERMS[lang]} />
        </div>
      )}
    </main>
  );
};

export default TermsOfUse;
